import analytics, { SEGMENT_EVENTS } from '@/utils/analytics';

export function segmentErrorTracking(
  displayedMessage: string,
  page: string,
  props?: any,
): void {
  if (!displayedMessage) return;

  analytics.track(SEGMENT_EVENTS.fe_self_serve_error, {
    displayedMessage,
    page,
    ...props,
  });
}
